import React from 'react'

export default function Contact() {
  return (
    <div>
      <h2 className='cont1'>Find Me On</h2>
      <h3 className='cont1'>Feel Free to Connect With Me</h3>
      <div className='cont-icons'>
      <span><a  href="https://github.com/MUSSAFARA-RIAZ"><i class="fa-brands fa-github"></i></a></span>
       <span><a  href="https://www.facebook.com/mussafira.ahmed"><i class="fa-brands fa-facebook-f"></i></a></span>
       <span><a  href="https://www.linkedin.com/in/mussafara-riaz-a38012213/"><i class="fa-brands fa-linkedin"></i></a></span>
       
      </div>
    </div>
  )
}